<template>

    <div class="section-card px-5 py-5 journal-stats-card">
      <v-container v-if="this.externalUser" class="fixed-component mt-n3 pa-1" fluid>
            <v-row align="center" justify="center">
                <v-col cols="1">
                    <v-btn class="mt-n7" @click="backToTrades">« {{ $t('btnBack') }}</v-btn>
                </v-col>
                <v-col class="ml-n3" cols="11">
                    <OverallFilters :external-user="externalUser" :external-user-id="externalUserId"/>
                </v-col>
            </v-row>
            <v-divider class="mb-5 mt-n5"/>
        </v-container>
        <div class="desktop">
        <PortfolioStats :insight="insights.pnl" @aggregates="onPnlAggregates"/>


      <v-divider class="my-5" />

        <div class="d-flex align-center">
          <h2>{{ $t('titles_JournalStats.asset') }}</h2>
          <!-- <v-chip v-if="!isEmbedded" small class="ml-3" @click="educationalVideo('Asset')">{{ $t('btnHowToUseIt') }}<v-icon small right>fa-info-circle</v-icon></v-chip> -->
        </div>
        <AssetStats :insight="insights.assets"/>

      <v-divider class="my-5" />

      <TimeStats :insight="insights.time"/>

      <v-divider class="my-5" />

        <StrategyStats :insight="insights.strategy"/>

      <v-divider class="my-5" />

        <SideMoodHmStats :insight="insights.sideMood"/>



        <!-- <div class="d-flex align-center">
          <h2>{{ $t('titles_JournalStats.swisetRatio') }}</h2>
          <v-chip v-if="!isEmbedded"  small class="ml-3" @click="educationalVideo('SwisetRatio')">{{ $t('btnHowToUseIt') }}<v-icon small right>fa-info-circle</v-icon></v-chip>
          <v-chip class="ml-2" small><p class="my-0" style="font-size: 14px;">PRO <v-icon class="mt-n1" color="accent" x-small>fa-star</v-icon></p></v-chip>
        </div>
        <SwisetRatioStats @goToPro="seeProAdvantages = true"/> -->

      <!-- <div class="d-flex align-center">
        <h2>{{ $t('titles_JournalStats.riskAndReturn') }}</h2>
        <v-chip class="ml-2" small>
          <p class="my-0" style="font-size: 14px;">PRO <v-icon class="mt-n1" color="accent" x-small>fa-star</v-icon></p>
        </v-chip>
      </div>
      <RiskReturnStats @goToPro="seeProAdvantages = true" /> -->

      <!-- <div class="d-flex align-center">
        <h2>{{ $t('titles_JournalStats.byMarket') }}</h2>
        <v-chip class="ml-2" small>
          <p class="my-0" style="font-size: 14px;">PRO <v-icon class="mt-n1" color="accent" x-small>fa-star</v-icon></p>
        </v-chip>
      </div>
      <ByMarketStats @goToPro="seeProAdvantages = true" /> -->

      <!-- Overlay for educational video!-->
      <v-overlay :dark="false" v-model="overlayVideo">
        <EducationalVideo :title="title" :video-url="videoUrl" @closeWindow="overlayVideo = false" />
      </v-overlay>

      <!-- Overlay for Upgrade to Pro!-->
      <v-overlay :dark="false" v-model="seeProAdvantages">
        <UpgradeToPro :message="messageUpgradeToPro" @closeWindow="seeProAdvantages = false" />
      </v-overlay>

      <!-- Overlay for Loading Trades!-->
      <v-overlay :dark="false" v-model="$store.state.book.loadingTrades">
        <lottie :options="lottieOptions" :height="250" :width="250" />
      </v-overlay>
    </div>
    <div class="mobile">
      <h3 class="text-center my-16">
        <v-icon class="d-flex align-center justify-center mt-12 mb-5" x-large>fa-regular fa-grin-beam-sweat</v-icon>
        {{ $t('messageMobile') }}
      </h3>
    </div>
  </div>
</template>

<script>

    import * as animationData from '@/assets/animations/loading.json';
    import AssetStats from "../AssetStats";
    import PortfolioStats from "../PortfolioStats";
    import TimeStats from "../TimeStats";
    import StrategyStats from "../StrategyStats";
    import SideMoodHmStats from "../SideMoodHmStats";
    import EducationalVideo from "../../../components/EducationalVideo";
    import SwisetRatioStats from "@/views/Journal/SwisetRatioStats";
    import RiskReturnStats from "@/views/Journal/RiskReturnStats";
    import UpgradeToPro from "@/components/UpgradeToPro";
    import ByMarketStats from "@/views/Journal/ByMarketStats";
    import OverallFilters from '../components/OverallFilters.vue';
    import {mapMutations} from 'vuex';
    import InsightsRepository from '@/repositories/insights';
    import { buildJournalAggregates } from '@/services/journalInsightAggregates';

    const INSIGHT_SECTIONS = ['pnl', 'assets', 'time', 'strategy', 'sideMood'];
    const INSIGHT_MIN_TRADES = 10;
    const INSIGHT_DEBOUNCE_MS = 1000;
    export default {
        name: "BookStats",
        components: {
          ByMarketStats,
          UpgradeToPro, RiskReturnStats, SwisetRatioStats, EducationalVideo, SideMoodHmStats, StrategyStats, TimeStats, PortfolioStats, AssetStats,OverallFilters
        },
        props: {
            externalUser: Boolean,
            externalUserId: Number,
        },
        inject:["isEmbedded"],
        mounted(){
            this.requestInsights();
        },
        beforeDestroy() {
            this.cancelInsights();
        },
        computed: {
            // AI insights: only the trader's own Journal (not broker/IB, not someone else's), and only Pro.
            insightsActive() {
                return !!this.$isTraderApp && !this.externalUser && !!this.$store.state.user.isPro;
            },
        },
        watch: {
            '$store.state.book.trades': function () {
                this.requestInsights();
            },
            '$i18n.locale': function () {
                this.requestInsights();
            },
            // isPro is loaded asynchronously by App.vue, after the first render.
            insightsActive: function () {
                this.requestInsights();
            },
        },
        data() {
            return {
                lottieOptions: { animationData: animationData.default, },
                seeProAdvantages: false,

                // section key -> { status, text, missing, trades }; a missing key means "show no bar"
                insights: {},
                pnlAggregates: null,
                insightTimer: null,
                insightRequestId: 0,
                insightSignature: '',
                messageUpgradeToPro: 'You cannot see pro stats. With Pro you can get all the professional statistics and more.',

      // Educational Video
      overlayVideo: false,
      title: 'Profitability Stats',
      videoUrl: 'n0kW2kozmxw',
    };
  },
  methods: {
    ...mapMutations(['setTradesPageable']),
    onPnlAggregates(aggregates) {
      this.pnlAggregates = aggregates;
      this.requestInsights();
    },
    cancelInsights() {
      clearTimeout(this.insightTimer);
      // A response still in flight belongs to an older request and is dropped.
      this.insightRequestId += 1;
    },
    resetInsights() {
      this.cancelInsights();
      this.insightSignature = '';
      this.insights = {};
    },
    // One request for the five sections. Debounced, and skipped when nothing changed since the last
    // one (e.g. toggling the PnL chart metric). The 10 trades minimum is checked here to save a request.
    requestInsights() {
      if (!this.insightsActive) {
        this.resetInsights();
        return;
      }
      const trades = this.$store.state.book.trades || [];
      const totalTrades = trades.length;
      if (totalTrades < INSIGHT_MIN_TRADES) {
        this.cancelInsights();
        this.insightSignature = '';
        const insights = {};
        INSIGHT_SECTIONS.forEach((key) => {
          insights[key] = { status: 'INSUFFICIENT_DATA', missing: ['MIN_TRADES'], trades: totalTrades };
        });
        this.insights = insights;
        return;
      }
      const sections = buildJournalAggregates(trades);
      if (this.pnlAggregates) {
        sections.pnl = this.pnlAggregates;
      }
      const keys = Object.keys(sections);
      const body = { language: this.$i18n.locale, totalTrades, sections };
      const signature = JSON.stringify(body);
      if (signature === this.insightSignature) {
        return;
      }
      this.cancelInsights();
      this.insightSignature = signature;
      const loading = {};
      keys.forEach((key) => {
        loading[key] = { status: 'loading' };
      });
      this.insights = loading;
      const requestId = this.insightRequestId;
      this.insightTimer = setTimeout(async () => {
        try {
          const response = await InsightsRepository.getJournalInsights(body);
          if (requestId !== this.insightRequestId) {
            return;
          }
          const data = response && response.data ? response.data : {};
          const resolved = {};
          keys.forEach((key) => {
            const result = data[key];
            if (result && result.status === 'OK' && result.insight) {
              resolved[key] = { status: 'OK', text: result.insight };
            } else if (result && result.status === 'INSUFFICIENT_DATA') {
              resolved[key] = { status: 'INSUFFICIENT_DATA', missing: result.missing || [], trades: totalTrades };
            }
          });
          this.insights = resolved;
        } catch (error) {
          // The insights are optional: on any failure the bars are simply hidden.
          if (requestId === this.insightRequestId) {
            this.resetInsights();
          }
        }
      }, INSIGHT_DEBOUNCE_MS);
    },
    backToTrades() {
      this.setTradesPageable({
        size: 15,
        page: 0,
        sort: 'openTime,desc',
      });
      this.$router.push((this.externalUser) ? '/book/shared' : '/book');
    },
    educationalVideo(stat) {
      switch (stat) {
        case 'Portfolio':
          this.title = this.$t('titles.portfolio');
          this.videoUrl = 'WFOaSVvkKe4';
          break;
        case 'Profitability':
          this.title = this.$t('titles.profitability');
          this.videoUrl = 'n0kW2kozmxw';
          break;
        case 'Asset':
          this.title = this.$t('titles.asset');
          this.videoUrl = 'COcgXbpa2gg';
          break;
        case 'Side':
          this.title = this.$t('titles.side');
          this.videoUrl = 'COPFcGvoQ84';
          break;
        case 'Time':
          this.title = this.$t('titles.time');
          this.videoUrl = 'bMzDWVvYfUE';
          break;
        case 'Mood':
          this.title = this.$t('titles.mood');
          this.videoUrl = 'Zl7rYLwYvaQ';
          break;
        case 'SwisetRatio':
          this.title = this.$t('titles.swisetRatio');
          this.videoUrl = 'JkzLCKGG_3g';
          break;
        default:
          this.title = this.$t('titles.strategy');
          this.videoUrl = '08H9np6sZvQ';
          break;
      }
      this.overlayVideo = true;
    },
    setChartsToDark() {
      
    }
  }
}
</script>



<style scoped>
.journal-stats-card {
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
}

.fixed-component {
  background-color: var(--v-light-base);
  position: relative;
  z-index: 1;
}

.old-filters {
  display: none;
}

@media (min-width: 600px) {
  .mobile {
    display: none;
  }
}

@media (max-width: 599px) {
  .desktop {
    display: none;
  }
}
</style>
